import type { FC } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import cn from 'classnames';
import { IDropdownOption } from '@ui-modules/types';
import { Checkbox } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

interface INoPassengersField {
  n_of_passengers: string;
  isEdit: boolean;
  paxOptions: IDropdownOption[];
}

const NoPassengersField: FC<INoPassengersField> = ({ isEdit, paxOptions, n_of_passengers }) => {
  const formApi = useFormApi();

  return (
    <div className={cn(css.field, css.withoutLabel)}>
      <Checkbox
        disabled={isEdit}
        label={`${t('common.no')} ${t('common.passengers')}`}
        name="no_passengers"
        type="primary"
        onChange={(state) => {
          if (state.value) {
            formApi.setValue(
              'n_of_passengers',
              paxOptions.find((i) => i.value === n_of_passengers),
            );
          }
        }}
        data-testid="mobility-planner-edit-form-no-pax"
      />
    </div>
  );
};

export default NoPassengersField;
